import { jsx as n } from "react/jsx-runtime";
import { u as i } from "./index-6a632112.mjs";
import { S as s } from "./cancelClose-87fdf326.mjs";
import { r as o, s as t } from "./themes-5f0b3c3d.mjs";
import "react";
import { IconButton as m } from "./iconButton.js";
import "./types-b577bf77.mjs";
import "./button.js";
import "./lineHeights-72d3110c.mjs";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
const h = (e) => {
  switch (e) {
    case "large":
      return { height: t["12x"], width: t["12x"] };
    case "medium":
      return { height: t["10x"], width: t["10x"] };
    case "small":
      return { height: t["8x"], width: t["8x"] };
    case "xsmall":
      return { height: t["6x"], width: t["6x"] };
    case "xxsmall":
      return { height: t["5x"], width: t["5x"] };
    default:
      return { height: t["4x"], width: t["4x"] };
  }
}, g = (e) => {
  switch (e) {
    case "large":
      return `--svg-wrapper-height: ${t["8x"]}; --svg-wrapper-width: ${t["8x"]}`;
    case "xxsmall":
      return `--svg-wrapper-height: ${t["5x"]}; --svg-wrapper-width: ${t["5x"]}`;
    case "xxxsmall":
      return `--svg-wrapper-height: ${t["4x"]}; --svg-wrapper-width: ${t["4x"]}`;
    default:
      return `--svg-wrapper-height: ${t["6x"]}; --svg-wrapper-width: ${t["6x"]}`;
  }
}, d = i(m)`
  border: unset !important;
  padding: unset !important;
  ${(e) => h(e.size)};
  > span {
    ${({ size: e }) => g(e)};
    color: ${(e) => {
  if (e.$surface === "light")
    switch (e.$_iconvariant) {
      case "accent":
        return e.theme.components.closeButton.light.iconColor.accent;
      case "green":
        return e.theme.components.closeButton.light.iconColor.green;
      case "orange":
        return e.theme.components.closeButton.light.iconColor.orange;
      case "red":
        return e.theme.components.closeButton.light.iconColor.red;
      default:
        return e.theme.components.closeButton.light.iconColor.default;
    }
  else
    switch (e.$_iconvariant) {
      case "accent":
        return e.theme.components.closeButton.dark.iconColor.accent;
      case "green":
        return e.theme.components.closeButton.dark.iconColor.green;
      case "orange":
        return e.theme.components.closeButton.dark.iconColor.orange;
      case "red":
        return e.theme.components.closeButton.dark.iconColor.red;
      default:
        return e.theme.components.closeButton.dark.iconColor.default;
    }
}} !important;
  }
  &:hover {
    cursor: pointer;
    border-radius: ${({ size: e }) => e === "large" || e === "medium" || e === "small" ? o["2x"] : o["1x"]};
    background-color: ${(e) => {
  if (e.$surface === "light")
    switch (e.$_iconvariant) {
      case "accent":
        return e.theme.components.closeButton.light.backgroundColor.accent;
      case "green":
        return e.theme.components.closeButton.light.backgroundColor.green;
      case "orange":
        return e.theme.components.closeButton.light.backgroundColor.orange;
      case "red":
        return e.theme.components.closeButton.light.backgroundColor.red;
      default:
        return e.theme.components.closeButton.light.backgroundColor.default;
    }
  else
    switch (e.$_iconvariant) {
      case "accent":
        return e.theme.components.closeButton.dark.backgroundColor.accent;
      case "green":
        return e.theme.components.closeButton.dark.backgroundColor.green;
      case "orange":
        return e.theme.components.closeButton.dark.backgroundColor.orange;
      case "red":
        return e.theme.components.closeButton.dark.backgroundColor.red;
      default:
        return e.theme.components.closeButton.dark.backgroundColor.default;
    }
}} !important;
    && > span {
      color: ${(e) => {
  if (e.$surface === "light")
    switch (e.$_iconvariant) {
      case "accent":
        return e.theme.components.closeButton.light.iconColor.hoverAccent;
      case "green":
        return e.theme.components.closeButton.light.iconColor.hoverGreen;
      case "orange":
        return e.theme.components.closeButton.light.iconColor.hoverOrange;
      case "red":
        return e.theme.components.closeButton.light.iconColor.hoverRed;
      default:
        return e.theme.components.closeButton.light.iconColor.default;
    }
  else
    switch (e.$_iconvariant) {
      case "accent":
        return e.theme.components.closeButton.dark.iconColor.accent;
      case "green":
        return e.theme.components.closeButton.dark.iconColor.green;
      case "orange":
        return e.theme.components.closeButton.dark.iconColor.orange;
      case "red":
        return e.theme.components.closeButton.dark.iconColor.red;
      default:
        return e.theme.components.closeButton.dark.iconColor.default;
    }
}} !important;
    }
  }
  border-radius: ${({ size: e }) => e === "large" || e === "medium" || e === "small" ? o["2x"] : o["1x"]} !important;
`, j = ({
  surface: e = "light",
  variant: r = "default",
  size: c = "xxsmall",
  onClick: a,
  ariaLabel: l = "Close",
  ...u
}) => /* @__PURE__ */ n(
  d,
  {
    variant: "tertiary",
    size: c,
    $_iconvariant: r,
    $surface: e,
    onClick: a,
    icon: /* @__PURE__ */ n(s, {}),
    "aria-label": l,
    ...u
  }
);
export {
  j as CloseButton
};
